export const API_RESP_INIT = {
    "comparison Dashboard": {
        "DemandCharges": {
            "parameter": "Demand Charges (₹/kVA)",
            "beforeMYT": null,
            "afterMYT": null,
            "percentageChange": null
        },
        "EnergyCharges": {
            "parameter": "Energy Charges (₹/kWh)",
            "beforeMYT": null,
            "afterMYT": null,
            "percentageChange": null
        },
        "WheelingCharges": {
            "parameter": "Wheeling Charges (₹/kWh)",
            "beforeMYT": null,
            "afterMYT": null,
            "percentageChange": null
        }
    },
    "Zone-wise Rebates": {
        "zoneA": {
            "parameter": "ToD Zone A",
            "beforeMYT": null,
            "afterMYT": null,
            "percentageChange": null
        },
        "zoneB": {
            "parameter": "ToD Zone B",
            "beforeMYT": null,
            "afterMYT": null,
            "percentageChange": null
        },
        "zoneC": {
            "parameter": "ToD Zone C",
            "beforeMYT": null,
            "afterMYT": null,
            "percentageChange": null
        },
        "zoneD": {
            "parameter": "ToD Zone D",
            "beforeMYT": null,
            "afterMYT": null,
            "percentageChange": null
        }
    },
    "Sample Bill Comparison": {
        "units": 0,
        "components": {
            "DemandCharges": {
                "parameter": "Demand Charges",
                "oldTariff": null,
                "newTariff": null,
                "change": null
            },
            "EnergyCharges": {
                "parameter": "Energy Charges",
                "oldTariff": null,
                "newTariff": null,
                "change": null
            },
            "WheelingCharges": {
                "parameter": "Wheeling Charges",
                "oldTariff": null,
                "newTariff": null,
                "change": null
            },
            "ZoneRebates": {
                "parameter": "Zone Rebates",
                "oldTariff": null,
                "newTariff": null,
                "change": null
            },
            "FAC": {
                "parameter": "FAC @0/unit",
                "rate": null,
                "oldTariff": null,
                "newTariff": null,
                "change": null
            },
            "ElectricityDuty": {
                "parameter": "Electricity Duty ",
                "rate": null,
                "oldTariff": null,
                "newTariff": null,
                "change": null
            },
            "TaxOnSale": {
                "parameter": "Tax On Sale @0/unit",
                "rate": null,
                "oldTariff": null,
                "newTariff": null,
                "change": null
            }
        },
      
    },
    "Impact of Changes in ToD tariff and banking provisions": {
        "zoneA": {
            "name": "ToD Zone A",
            "beforeMYT": {
                "hours": null,
                "timeslot": null,
                "units": null,
                "rebateRate": null,
                "rebateAmount": null
            },
            "afterMYT": {
                "hours": null,
                "timeslot": null,
                "units": null,
                "rebateRate": null,
                "rebateAmount": null
            }
        },
        "zoneB": {
            "name": "ToD Zone B",
            "beforeMYT": {
                "hours": null,
                "timeslot": null,
                "units": null,
                "rebateRate": null,
                "rebateAmount": null
            },
            "afterMYT": {
                "hours": null,
                "timeslot": null,
                "units": null,
                "rebateRate": null,
                "rebateAmount": null
            }
        },
        "zoneC": {
            "name": "ToD Zone C",
            "beforeMYT": {
                "hours": null,
                "timeslot": null,
                "units": null,
                "rebateRate": null,
                "rebateAmount": null
            },
            "afterMYT": {
                "hours": null,
                "timeslot": null,
                "units": null,
                "rebateRate": null,
                "rebateAmount": null
            }
        },
        "zoneD": {
            "name": "ToD Zone D",
            "beforeMYT": {
                "hours": null,
                "timeslot": null,
                "units": null,
                "rebateRate": null,
                "rebateAmount": null
            },
            "afterMYT": {
                "hours": null,
                "timeslot": null,
                "units": null,
                "rebateRate": null,
                "rebateAmount": null
            }
        }
    }
}


export const RATINGS = [
  {
    label: "AAA",
    value: "AAA",
  },
  {
    label: "AA",
    value: "AA",
  },
   {
    label: "A",
    value: "A",
  },
   {
    label: "BBB",
    value: "BBB",
  },
   {
    label: "Mixed (AA + A)",
    value: "Mixed",
  },
];
